/* src/app/core/components/license-attribution/license-attribution.component.scss */
.f-width {
  max-width: 400px;
}
/*# sourceMappingURL=license-attribution.component.css.map */
